/* eslint-disable max-len */
import React, { useContext } from 'react';
import { ControlledDateTimePickerContext } from '../../../ControlledDateTimePickerCTX.js';
import { CalendarIconTrigger } from './CalendarIconTrigger.js';
import { CalendarWrapper } from './CalendarWrapper.js';
import { CalendarContext } from './CalendarContext.js';
import { useConfigCalendarCTX } from './useConfigCalendarCTX.js';

export const WrappedCalendarContext = ({ children }: { children: JSX.Element }) => {
  const ctx = useConfigCalendarCTX();
  return <CalendarContext.Provider value={ctx}>{children}</CalendarContext.Provider>;
};

const CalendarContent = () => {
  const { showCalendar, handleMenuWrapperKeyDown } = useContext(CalendarContext);
  const { isControllerOnly } = useContext(ControlledDateTimePickerContext);
  return (
    <>
      {isControllerOnly ? null : <CalendarIconTrigger />}
      {isControllerOnly || showCalendar ? (
        <>
          {/* The <div> element is catching the "ESC" key to close the calendar, there is no valid aria role for this */}
          {/* https://github.com/jsx-eslint/eslint-plugin-jsx-a11y/blob/master/docs/rules/no-static-element-interactions.md#case-the-event-handler-is-only-being-used-to-capture-bubbled-events */}
          {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
          <div onKeyDown={handleMenuWrapperKeyDown}>
            <CalendarWrapper />
          </div>
        </>
      ) : null}
    </>
  );
};

// we wrap in context in a separate statement so we can use the useContext and be sure it's correctly initialized
export const Calendar = () => (
  <WrappedCalendarContext>
    <CalendarContent />
  </WrappedCalendarContext>
);
